import { gql } from '@apollo/client/core'


export const UPDATE_USER_TIMEZONE = gql`
  mutation UpdateUserTimezone($input: UpdateTimezoneInput!) {
    updateUserTimezone(input: $input) {
      id
      calendar_id
      timezone
      created_at
      updated_at
    }
  }
`

export const UPDATE_WORKING_HOURS = gql`
  mutation UpdateWorkingHours($customerId: Int!, $clinicId: Int!, $input: WeeklyHoursInput!) {
    updateWorkingHours(customerId: $customerId, clinicId: $clinicId, input: $input) {
      success
      message
      calendar_id
      updated_schedule {
        weekday
        start_time
        end_time
      }
    }
  }
`

// schedule exception
export const ADD_BATCH_SCHEDULE_EXCEPTION = gql`
  mutation AddBatchScheduleExceptions($customerId: Int!, $clinicId: Int!, $input: BatchScheduleExceptionInput!) {
    addBatchScheduleExceptions(customerId: $customerId, clinicId: $clinicId, input: $input) {
      success
      created
      failed

      error_messages
      message
    }
  }
`

export const DELETE_SCHEDULE_EXCEPTION = gql`
  mutation DeleteScheduleException($input: DeleteScheduleExceptionInput!) {
    deleteScheduleException(input: $input) {
      success
      exception_id
      message
    }
  }
`

export const UPDATE_SCHEDULE_EXCEPTION = gql`
  mutation UpdateScheduleException($input: UpdateScheduleExceptionInput!) {
    updateScheduleException(input: $input) {
      success
      exception_id
      exception {
        exception_id
        date
        start_time
        end_time
        is_available
      }
      message
    }
  }
`

// min max and duration
export const UPDATE_USER_BOOKING_RULES = gql`
  mutation UpdateUserBookingRules($input: UpdateBookingRulesInput!) {
    updateUserBookingRules(input: $input) {
      id
      min_notice_minutes
      max_advance_days
      default_appointment_duration
      timezone
      created_at
      updated_at
    }
  }
`




// practice event type
export const CREATE_PRACTICE_EVENT_TYPE = gql`
  mutation CreatePracticeEventType($input: PracticeEventTypeInput!) {
    createPracticeEventType(input: $input) {
      id
      practice_id
      name
      color_hex
      created_by
      updated_by
      created_at
      updated_at
    }
  }
`

export const UPDATE_PRACTICE_EVENT_TYPE_COLOR = gql`
  mutation UpdatePracticeEventType($id: Int!, $input: UpdatePracticeEventTypeInput!) {
    updatePracticeEventType(id: $id, input: $input) {
      id
      practice_id
      name
      color_hex
      created_by
      updated_by
      created_at
      updated_at
    }
  }
`

export const DELETE_PRACTICE_EVENT_TYPE = gql`
  mutation DeletePracticeEventType($id: Int!) {
    deletePracticeEventType(id: $id) {
      id
      practice_id
      name
      color_hex
      created_by
      updated_by
      created_at
      updated_at
    }
  }
`



